export default __webpack_public_path__ + "static/media/kiama1.a5e547bf.jpg";